module.exports = __webpack_public_path__ + "img/side-icon2.f9cee08d.svg";